export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20theater%20interior%20with%20warm%20deep%20red%20velvet%20curtains%20and%20soft%20golden%20stage%20lighting%2C%20elegant%20movie%20premiere%20atmosphere%2C%20deep%20burgundy%20and%20charcoal%20tones%2C%20no%20people%2C%20abstract%20dramatic%20composition%2C%20film%20grain%20texture%2C%20professional%20cinematography%20lighting&width=1600&height=900&seq=hero-bg-rose-video&orientation=landscape"
        alt="玫瑰视频 - 沉浸式观影体验"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/50 to-foreground-950/80"></div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-2 mb-5">
              <span className="px-3 py-1 text-xs font-medium bg-primary-500/20 text-primary-300 border border-primary-500/30 rounded-full whitespace-nowrap">
                高清流畅
              </span>
              <span className="px-3 py-1 text-xs font-medium bg-accent-500/20 text-accent-300 border border-accent-500/30 rounded-full whitespace-nowrap">
                海量片源
              </span>
              <span className="px-3 py-1 text-xs font-medium bg-secondary-500/20 text-secondary-300 border border-secondary-500/30 rounded-full whitespace-nowrap">
                极速更新
              </span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 leading-tight">
              玫瑰视频
              <span className="block text-xl md:text-2xl lg:text-3xl font-body font-medium text-background-50/80 mt-2">
                高清免费在线追剧观影平台
              </span>
            </h1>

            <p className="mt-2 text-sm md:text-base font-body text-background-50/60 font-light tracking-wide">
              红桃樱桃茄子糖心 · 多平台资源一站聚合
            </p>

            <p className="mt-6 text-sm md:text-base text-background-50/70 leading-relaxed max-w-xl mx-auto lg:mx-0">
              玫瑰视频深度整合红桃视频、樱桃视频、茄子视频、糖心视频等主流平台高清资源，
              每日实时同步最新电视剧全集与电影大片，支持多线路无缝切换，画质清晰不缓冲。
              无论热门新番还是经典老片，一键搜索即刻畅享，做你贴心的追剧观影管家。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-8 mt-7">
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500/20">
                  <i className="ri-flashlight-line text-primary-400 text-sm"></i>
                </span>
                <span className="text-xs md:text-sm text-background-50/80">全网热剧实时同步</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-500/20">
                  <i className="ri-film-line text-accent-400 text-sm"></i>
                </span>
                <span className="text-xs md:text-sm text-background-50/80">数万部影片随心看</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-500/20">
                  <i className="ri-4k-line text-secondary-400 text-sm"></i>
                </span>
                <span className="text-xs md:text-sm text-background-50/80">画质流畅不卡顿</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <a
                href="#carousel"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-base"></i>
                开始追剧
              </a>
              <a
                href="#media"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#media')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/10 hover:bg-background-50/20 text-background-50 border border-background-50/20 font-medium text-sm rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-live-line text-base"></i>
                浏览精选
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative rounded-xl overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20streaming%20platform%20interface%20mockup%20floating%20on%20a%20dark%20gradient%20background%2C%20elegant%20movie%20poster%20thumbnails%20arranged%20in%20a%20sleek%20grid%2C%20warm%20rose%20gold%20accent%20highlights%2C%20premium%20OTT%20app%20aesthetic%2C%20glassmorphism%20ui%20elements%2C%203D%20floating%20effect%2C%20cinematic%20color%20grading&width=1200&height=800&seq=hero-main-rose-video&orientation=landscape"
                alt="玫瑰视频平台界面预览"
                className="w-full h-auto rounded-xl"
              />
              <div className="absolute inset-0 rounded-xl border border-background-50/10 pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}